export let typingTimer: NodeJS.Timeout | undefined
const delay = 1000

export function startTypingTimer(callback: () => void) {
  clearTimeout(typingTimer)
  typingTimer = setTimeout(callback, delay)
}
